// src/hooks/useCountries.ts
import { graphql, useStaticQuery } from "gatsby";
type Country = {
  id: string;
  name: string;
  redirectUrl: string;
  placeId: string;
};
type QueryResult = {
  allCountry: {
    edges: {
      node: Country;
    }[];
  };
};
const useCountries = (): Country[] => {
  const data: QueryResult = useStaticQuery(graphql`
    query {
      allCountry {
        edges {
          node {
            id
            name
            redirectUrl
            placeId
          }
        }
      }
    }
  `);
  return data.allCountry.edges.map((edge) => edge.node);
};
export default useCountries;
